"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManyToMany = exports.ManyToOne = exports.OneToMany = exports.OneToOne = void 0;
const OneToMany_1 = require("./OneToMany");
Object.defineProperty(exports, "OneToMany", { enumerable: true, get: function () { return OneToMany_1.OneToMany; } });
const OneToOne_1 = require("./OneToOne");
Object.defineProperty(exports, "OneToOne", { enumerable: true, get: function () { return OneToOne_1.OneToOne; } });
const ManyToOne_1 = require("./ManyToOne");
Object.defineProperty(exports, "ManyToOne", { enumerable: true, get: function () { return ManyToOne_1.ManyToOne; } });
const ManyToMany_1 = require("./ManyToMany");
Object.defineProperty(exports, "ManyToMany", { enumerable: true, get: function () { return ManyToMany_1.ManyToMany; } });
//# sourceMappingURL=index.js.map